import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import {
  InteractionStatus,
  InteractionRequiredAuthError,
  AccountInfo,
} from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Link } from "react-router-dom";
import { loginRequest } from "../authConfig";
import Avatar from "@mui/material/Avatar";
import { useProfileAvatarData } from "../hooks/useProfileAvatarData";
import { ProfileAvatarData } from "../services/ProfileService";
import { theme } from "../styles/theme";

const UserAvatar = (props: {
  width: number;
  height: number;
  margin: string;
  fontSize: string;
  isLink: boolean;
  linkTo?: string;
}) => {
  const { instance, inProgress } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [avatarData, setAvatarData] = useState<null | ProfileAvatarData>(null);
  const location = useLocation();

  const sx = {
    width: props.width,
    height: props.height,
    margin: props.margin,
    fontSize: props.fontSize,
    boxShadow: 1,
    bgcolor: theme.palette.primary.main
  };

  useEffect(() => {

    if (!avatarData && inProgress === InteractionStatus.None) {
      setIsLoading(true);

      useProfileAvatarData(inProgress, instance).then(response => {
        setAvatarData(response)
      }
      ).catch((e) => {
        if (e instanceof InteractionRequiredAuthError) {
          instance.acquireTokenRedirect({
            ...loginRequest,
            account: instance.getActiveAccount() as AccountInfo
          });
        }
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }, [inProgress, avatarData, instance]);


  if (!isLoading && avatarData) {
    return (
      <>
        {props.isLink && props.linkTo && (
          <Avatar
            alt={avatarData.initials}
            src={avatarData.profileImageUrl}
            sx={sx}
            component={Link}
            to={props.linkTo}
            state={{ from: location.pathname }}
          >
            {avatarData.initials}
          </Avatar>
        )}
        {!props.isLink && (
          <Avatar
            alt={avatarData.initials}
            src={avatarData.profileImageUrl}
            sx={sx}
          >
            {avatarData.initials}
          </Avatar>
        )}
      </>
    );
  } else {
    return <Avatar alt="" src="" sx={sx} />;
  }
};
export default UserAvatar;
